"use client"

import { TransformedStoreItem } from "@/(admin)/modules/ui-builder/config/themes/tamda-foods/StoreLocator/types"
import { transformStoreData } from "@/(admin)/modules/ui-builder/config/themes/tamda-foods/StoreLocator/utils/utils"
import { useUIBuilderLocaleStore } from "@/(admin)/modules/ui-builder/store/useUIBuilderLocaleStore"
import { useStores } from "@/hook/useStores"
import { Select, Typography } from "antd"
import { useEffect, useMemo, useState } from "react"

export interface StoreSelectValue {
    storeId: number
    storeName: string
}

export interface StoreSelectProps {
    value?: StoreSelectValue
    onChange: (value: StoreSelectValue | undefined) => void
    label?: string
    placeholder?: string
    pageSize?: number
}

export function StoreSelect({
    value,
    onChange,
    label = "Select Store",
    placeholder = "Select Store",
    pageSize = 100,
}: StoreSelectProps) {
    // Chỉ chạy trong editor nên lấy locale của blockContent đang sửa, để danh sách store
    // (và id được lưu) khớp đúng ngôn ngữ của trang.
    const locale = useUIBuilderLocaleStore(state => state.locale)
    const { stores: rawStores, loading: hookLoading } = useStores({ pageSize, locale })
    const stores = transformStoreData(rawStores)
    const [allStores, setAllStores] = useState<TransformedStoreItem[]>([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (stores && stores.length > 0) {
            setAllStores(stores)
        }
    }, [stores])

    const options = useMemo(
        () => [
            { value: "all", label: "Tất cả" },
            ...allStores.map((store: TransformedStoreItem) => ({
                value: store.id,
                label: store.name,
            })),
        ],
        [allStores]
    )

    const handleChange = (selectedValue: number | string) => {
        if (selectedValue === "all") {
            onChange(undefined)
            return
        }
        const selectedStore = allStores.find((store) => store.id === selectedValue)
        if (selectedStore && onChange) {
            onChange({
                storeId: selectedValue as number,
                storeName: selectedStore.name,
            })
        }
    }

    return (
        <div>
            <Typography.Title level={5}>{label}</Typography.Title>
            <Select
                value={value?.storeId ?? "all"}
                onChange={handleChange}
                options={options}
                className="w-full"
                loading={hookLoading || loading}
                placeholder={placeholder}
                showSearch
                filterOption={(input, option) =>
                    (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                }
            />
        </div>
    )
}
